// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '메디카코리아',
  targetSheetName: 'Table 1',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 2,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
    commissionRate: '기본',
    commissionNote: '비 고',
  },
  requiredHeaders: [
    'No',
    '구 분',
    '성분 및 함량',
    '제품명',
    '대조약',
    '보험약가',
    '보험코드',
    '포장단위',
    '기본',
    '추가',
    '비 고',
  ],
});
